import React, { Component } from 'react';
import { connect } from "react-redux";
import { Grid, Row, Col, Image } from 'react-bootstrap';
import { setImage } from "../../redux/actionCreators";
import './advancedElectronicSignature.css';
import config from '../../config/config';
import FooterContainer from '../../components/footer/FooterContainer';
import MainButton from '../../components/buttons/main_button/MainButton';

class AdvancedElectronicSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: config.process_time,
  };
    this.replaceText = this.replaceText.bind(this);
    this.refreshTimer = this.refreshTimer.bind(this);
  }
  timeUnit = config.process_time_unit_label;

  componentDidMount() {
    this.refreshTimer();
  }

  componentDidUpdate(prevProps) {
    if (this.props.expiration !== undefined && this.props.expirationSecondsToken !== undefined &&
        (
            this.props.expiration !== prevProps.expiration
            ||
            this.props.expirationSecondsToken !== prevProps.expirationSecondsToken
        )
    ) {
        this.refreshTimer();
    }
  }

  refreshTimer = () => {
    const actualDate = new Date();
    const expirationToken = this.props.expirationSecondsToken / 60;
    const diff = (Math.abs(this.props.expiration - actualDate) / 1000 / 60);
    let newDiff;
    if (diff > 1440) {
        newDiff = (diff / 60) / 24;
        this.timeUnit = config.process_time_unit_days;
    } else if (1440 >= diff && diff > 60) {
        newDiff = diff / 60;
        this.timeUnit = config.process_time_unit_hours;
    } else {
        newDiff = diff;
    }
    this.setState({
        percentage: ((diff * 100) / expirationToken),
        time: Math.ceil(newDiff),
    });
};

  replaceText(text, ...args) {
    const n = args.length;
    const regex = /\{(\d+)\}/;
    for (let i = 0; i < n; i++) {
      text = text.replace(regex, args[i]);
    }
    return text;
  }

  render() {
    let data = this.props.data ? this.props.data : this.props.stepData;
    data = data ? data : {};
    let icon;
    if (this.props.stepInfo.icon) {
        icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
    }
    return (
      <div className={'instruction-advance-electronic-signature full-security'}>
        <Grid>
          <div className={'content'}>
            <div className={'break-top'}></div>
            <Row>
              <Col xs={12}>
                <p className={'number'}>
                  {this.props.stepInfo.number}
                </p>
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={12}>
                <h1 className={'title'}>{this.props.stepInfo.title}</h1>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <div className="image">
                  <Image src={icon} />
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <p className={'description'}>
                  {this.props.stepInfo.description}
                </p>
              </Col>
              {this.props.stepInfo.additional && this.props.stepInfo.additional !== '' &&
                <Col xs={12}>
                  <p className={'additional'}>
                    <span className={'warning-icon'}>!</span>
                    {this.replaceText(this.props.stepInfo.additional, this.state.time + ' ' + this.timeUnit.toLowerCase())}
                  </p>
                </Col>
              }
            </Row>
            <FooterContainer>
              <MainButton 
                onClick={this.props.nextStep}
                text={this.props.stepInfo.buttonText}
              />
            </FooterContainer>
          </div>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    code: state.code,
    stepInfo: state.stepInfo,
    data: state.data,
    stepData: state.stepData,
    image: state.image,
    expiration: state.expiration,
    expirationSecondsToken: state.expirationSecondsToken,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setImage(image) {
      dispatch(setImage(image));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedElectronicSignature);
